/**
 * UI adapter: UC-35 SwitchUndergroundLayer
 */
import type { UndergroundLayer } from '../../../../types/underground';
import { architectureFeatures } from '../../../infrastructure/config/features';
import { switchUndergroundLayerUseCase } from '../../../infrastructure/di/container';
import { SwitchUndergroundLayerUseCase } from '../../../application/use-cases/SwitchUndergroundLayerUseCase';
import { getLayerManager } from '../../../../services/layerManagerInstance';
import type { SwitchUndergroundLayerOutput } from '../../../application/use-cases/SwitchUndergroundLayerUseCase';

export function resolveSwitchUndergroundLayer(
  targetLayer: UndergroundLayer,
  duration?: number,
): SwitchUndergroundLayerOutput {
  if (architectureFeatures.useLayerSwitchUseCase) {
    return switchUndergroundLayerUseCase.execute({ targetLayer, duration });
  }

  const manager = getLayerManager();
  const previousLayer = manager.getCurrentState().currentLayer;
  if (manager.getCurrentState().isTransitioning) {
    return { ok: false, reason: 'transition_in_progress', previousLayer };
  }
  if (previousLayer === targetLayer) {
    return { ok: true, skipped: true, previousLayer, targetLayer };
  }
  manager.switchToLayer(targetLayer, duration);
  return { ok: true, previousLayer, targetLayer };
}